module.exports = {"420106001":"积玉桥街","420106002":"杨园街","420106003":"徐家棚街","420106005":"粮道街","420106006":"中华路街","420106007":"黄鹤楼街","420106008":"紫阳街","420106009":"白沙洲街","420106010":"首义路街","420106011":"中南路街","420106012":"水果湖街","420106013":"珞珈山街","420106014":"石洞街","420106015":"南湖街","420106490":"东湖风景区街道（武昌）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420106.json
// module id = 1702
// module chunks = 0